document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/**
 * Position-aware hover effect for .btn-link buttons.
 *
 * The button's `::after` overlay sits at width/height 0, centred via
 * `transform: translate(-50%, -50%)` and positioned via the `--pa-x` / `--pa-y`
 * custom properties. On hover it grows to 300% w/h, expanding outwards from
 * whatever point `top`/`left` resolve to. This script writes those custom
 * properties to the cursor's entry point on mouseenter and its exit point on
 * mouseleave, so the shape grows in / shrinks out from the side the cursor
 * came from.
 *
 * Original jQuery reference: https://codepen.io/kjbrum/pen/wBBLXx
 */
function initPositionAwareButtons() {
	const buttons = document.querySelectorAll('.btn-link:not(.btn-link--text)');
	if (!buttons.length) return;

	buttons.forEach((button) => {
		const updatePosition = (event) => {
			const rect = button.getBoundingClientRect();
			button.style.setProperty('--pa-x', `${event.clientX - rect.left}px`);
			button.style.setProperty('--pa-y', `${event.clientY - rect.top}px`);
		};

		button.addEventListener('mouseenter', updatePosition);
		button.addEventListener('mouseleave', updatePosition);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initPositionAwareButtons);
} else {
	initPositionAwareButtons();
}
